import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CanvasElementComponent } from '../../canvas-elements/element-component';
import { CanvasElementBaseNavigationComponent } from '../__base/base-navigation.component';

@Component({
  selector: 'be-nav-sidebar',
  templateUrl: './nav-sidebar.component.html',
  styleUrls: ['./nav-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavSidebarComponent
  extends CanvasElementBaseNavigationComponent<'navSidebar'>
  implements CanvasElementComponent<'navSidebar'> {}
